import { mockCourses, mockBatches, mockStudents, mockEvaluations, mockBatchEnrollments, mockAssignments, subscriptionLimits, mockChapters, mockTopics, mockDifficultyLevels, mockSources, mockEvaluationTypes, mockLocations, mockStatuses, mockCurricula, mockSubjects, mockAcademicClasses } from "./mockData";

const EVALUATIONS_STORAGE_KEY = "mock_evaluations_store_v3";

const getEvaluationsStore = () => {
    try {
        const stored = localStorage.getItem(EVALUATIONS_STORAGE_KEY);
        if (stored) {
            const parsed = JSON.parse(stored);
            if (Array.isArray(parsed) && parsed.length > 0) {
                return parsed;
            }
        }
    } catch (e) {
        console.warn("Could not read mock_evaluations_store_v3 from localStorage", e);
    }
    try {
        localStorage.setItem(EVALUATIONS_STORAGE_KEY, JSON.stringify(mockEvaluations));
    } catch {}
    return [...mockEvaluations];
};

const saveEvaluationsStore = (items) => {
    try {
        localStorage.setItem(EVALUATIONS_STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
        console.warn("Could not save mock_evaluations_store_v3 to localStorage", e);
    }
};

let evaluationsDataStore = getEvaluationsStore();

export function mockData(method, endpoint, body) {
    console.log(`[MOCK API] ${method} ${endpoint}`, body || "");
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            let dataStore;
            let idPrefix = "";

            // Determine which data store to use based on endpoint
            if (endpoint.includes("/courses")) {
                dataStore = mockCourses;
                idPrefix = "c";
            } else if (endpoint.includes("/batches")) {
                dataStore = mockBatches;
                idPrefix = "b";
            } else if (endpoint.includes("/students")) {
                dataStore = mockStudents;
                idPrefix = "s";
            } else if (endpoint.includes("/evaluations")) {
                evaluationsDataStore = getEvaluationsStore();
                dataStore = evaluationsDataStore;
                idPrefix = "e";
            } else if (endpoint.includes("/batch-enrollments")) {
                dataStore = mockBatchEnrollments;
                idPrefix = "be";
            } else if (endpoint.includes("/assignments")) {
                dataStore = mockAssignments;
                idPrefix = "a";
            } else if (endpoint.includes("/subscription")) {
                // Handle subscription endpoints
                console.log(`[MOCK API] Handling subscription endpoint: ${endpoint}`);

                if (method === "GET" && endpoint.includes("/limits")) {


                    console.log(`[MOCK API] Returning subscription limits:`, subscriptionLimits);
                    resolve(subscriptionLimits);
                    return;
                }

                resolve({});
                return;
            } else if (endpoint.includes("/master-data")) {
                // Master data endpoints - handled separately
                console.log(`[MOCK API] Handling master data endpoint: ${endpoint}`);

                // Handle master data GET requests
                if (method === "GET") {
                    const dataType = endpoint.split("/").pop();
                    let result;

                    switch (dataType) {
                        case "chapters":
                            result = mockChapters;
                            break;
                        case "topics":
                            result = mockTopics;
                            break;
                        case "difficulty-levels":
                            result = mockDifficultyLevels;
                            break;
                        case "sources":
                            result = mockSources;
                            break;
                        case "evaluation-types":
                            result = mockEvaluationTypes;
                            break;
                        case "locations":
                            result = mockLocations;
                            break;
                        case "statuses":
                            result = mockStatuses;
                            break;
                        case "curricula":
                            result = mockCurricula;
                            break;
                        case "subjects":
                            result = mockSubjects;
                            break;
                        case "academic-classes":
                            result = mockAcademicClasses;
                            break;
                        case "all":
                            result = {
                                chapters: mockChapters,
                                topics: mockTopics,
                                difficultyLevels: mockDifficultyLevels,
                                sources: mockSources,
                                evaluationTypes: mockEvaluationTypes,
                                locations: mockLocations,
                                statuses: mockStatuses,
                                curricula: mockCurricula,
                                subjects: mockSubjects,
                                academicClasses: mockAcademicClasses,
                            };
                            break;
                        default:
                            result = [];
                    }

                    console.log(`[MOCK API] Returning master data for ${dataType}:`, result);
                    resolve(result);
                    return;
                }

                // Handle topics by chapter
                if (endpoint.includes("/topics/chapter/")) {
                    if (method === "GET") {
                        const chapterId = endpoint.split("/").pop();
                        const chapterName = mockChapters.find(c => c.id == chapterId)?.name;
                        if (chapterName) {
                            const topics = mockTopics.filter(topic => topic.chapterName === chapterName);
                            console.log(`[MOCK API] Returning topics for chapter ${chapterName}:`, topics);
                            resolve(topics);
                            return;
                        }
                        resolve([]);
                        return;
                    }
                }

                // Handle chapters by subject
                if (endpoint.includes("/chapters/subject/")) {
                    if (method === "GET") {
                        const subject = endpoint.split("/").pop();
                        const chapters = mockChapters.filter(chapter => chapter.subject === subject);
                        console.log(`[MOCK API] Returning chapters for subject ${subject}:`, chapters);
                        resolve(chapters);
                        return;
                    }
                }

                // Handle chapters by curriculum
                if (endpoint.includes("/chapters/curriculum/")) {
                    if (method === "GET") {
                        const curriculum = endpoint.split("/").pop();
                        const chapters = mockChapters.filter(chapter => chapter.curriculum === curriculum);
                        console.log(`[MOCK API] Returning chapters for curriculum ${curriculum}:`, chapters);
                        resolve(chapters);
                        return;
                    }
                }

                // Handle chapters by academic class
                if (endpoint.includes("/chapters/academic-class/")) {
                    if (method === "GET") {
                        const academicClass = endpoint.split("/").pop();
                        const chapters = mockChapters.filter(chapter => chapter.academicClass === academicClass);
                        console.log(`[MOCK API] Returning chapters for academic class ${academicClass}:`, chapters);
                        resolve(chapters);
                        return;
                    }
                }

                // Handle subjects by curriculum
                if (endpoint.includes("/subjects/curriculum/")) {
                    if (method === "GET") {
                        const curriculum = endpoint.split("/").pop();
                        const subjects = mockSubjects.filter(subject => mockChapters.some(chapter => chapter.subject === subject.value && chapter.curriculum === curriculum
                        )
                        );
                        console.log(`[MOCK API] Returning subjects for curriculum ${curriculum}:`, subjects);
                        resolve(subjects);
                        return;
                    }
                }

                // Handle academic classes by curriculum
                if (endpoint.includes("/academic-classes/curriculum/")) {
                    if (method === "GET") {
                        const curriculum = endpoint.split("/").pop();
                        const academicClasses = mockAcademicClasses.filter(academicClass => mockChapters.some(chapter => chapter.academicClass === academicClass.value && chapter.curriculum === curriculum
                        )
                        );
                        console.log(`[MOCK API] Returning academic classes for curriculum ${curriculum}:`, academicClasses);
                        resolve(academicClasses);
                        return;
                    }
                }

                resolve([]);
                return;
            } else {
                console.error(`[MOCK API] Unknown endpoint: ${endpoint}`);
                return reject(new Error(`Unknown mock endpoint: ${endpoint}`));
            }

            if (method === "POST") {
                const newId = dataStore.length + 1; // Use numeric ID instead of string prefix
                const newItem = {
                    ...body,
                    id: newId,
                    createdDate: new Date().toISOString(),
                    updatedDate: new Date().toISOString(),
                    createdBy: "currentUser",
                    updatedBy: "currentUser",
                };

                // Handle different POST endpoints
                if (endpoint.includes("/courses")) {
                    mockCourses.push(newItem);
                } else if (endpoint.includes("/batches")) {
                    mockBatches.push(newItem);
                } else if (endpoint.includes("/students")) {
                    mockStudents.push(newItem);
                } else if (endpoint.includes("/batch-enrollments")) {
                    mockBatchEnrollments.push(newItem);
                } else if (endpoint.includes("/evaluations")) {
                    evaluationsDataStore.push(newItem);
                    saveEvaluationsStore(evaluationsDataStore);
                } else if (endpoint.includes("/assignments/batch")) {
                    // Handle batch assignment - create assignments for all students in the batch
                    const batchId = endpoint.match(
                        /\/assignments\/batch\/([^\/]+)/
                    )?.[1];
                    const batchStudents = mockStudents.filter(
                        (student) => student.batchId === parseInt(batchId)
                    );
                    const evaluation = body.evaluation; // Get evaluation DTO from the request body
                    const evaluationId = evaluation.id; // Extract evaluation ID from the DTO

                    console.log(`[MOCK API] Assignment creation - batchId: ${batchId}, evaluationId: ${evaluationId}`);
                    console.log(`[MOCK API] Found ${batchStudents.length} students in batch ${batchId}:`, batchStudents);

                    // Find the batch object
                    const batchObject = mockBatches.find(b => b.id === parseInt(batchId));

                    // Create assignments for all students in the batch
                    const newAssignments = batchStudents.map((student, index) => ({
                        id: mockAssignments.length + index + 1, // Use numeric ID
                        evaluationLink: parseInt(evaluationId), // Convert to number for consistency
                        sentDateTime: body.sentDateTime,
                        expiryDateTime: body.expiryDateTime,
                        isActive: body.isActive,
                        score: null,
                        strengthAreas: "",
                        improvementAreas: "",
                        timeTaken: null,
                        submittedDateTime: null,
                        feedback: "",
                        createdDate: new Date().toISOString(),
                        updatedDate: new Date().toISOString(),
                        createdBy: "currentUser",
                        updatedBy: "currentUser",
                        student: student, // Include student object for frontend
                        batch: batchObject, // Include batch object for frontend
                        evaluation: evaluation, // Use evaluation DTO from request body
                    }));

                    mockAssignments.push(...newAssignments);
                    console.log(
                        `[MOCK API] Created ${newAssignments.length} assignments for batch ${batchId}`
                    );
                    resolve({
                        success: true,
                        assignmentsCreated: newAssignments.length,
                    });
                    return;
                }
                resolve(newItem);
            } else if (method === "PUT" || method === "PATCH") {
                const targetId = body?.id ?? endpoint.match(/\/([^/?]+)$/)?.[1];
                const index = dataStore.findIndex((item) => item.id == targetId); // Use == for type coercion
                if (index !== -1) {
                    const updatedItem = {
                        ...dataStore[index],
                        ...body,
                        id: dataStore[index].id,
                        updatedDate: new Date().toISOString(),
                        updatedBy: "currentUser",
                    };

                    // Handle different PUT/PATCH endpoints
                    if (endpoint.includes("/courses")) {
                        mockCourses[index] = updatedItem;
                    } else if (endpoint.includes("/batches")) {
                        mockBatches[index] = updatedItem;
                    } else if (endpoint.includes("/students")) {
                        mockStudents[index] = updatedItem;
                    } else if (endpoint.includes("/batch-enrollments")) {
                        mockBatchEnrollments[index] = updatedItem;
                    } else if (endpoint.includes("/evaluations")) {
                        evaluationsDataStore[index] = updatedItem;
                        saveEvaluationsStore(evaluationsDataStore);
                    }
                    resolve(updatedItem);
                } else {
                    reject(new Error("Item not found for update in mock data"));
                }
            } else if (method === "DELETE") {
                const targetId = body?.id ?? endpoint.match(/\/([^/?]+)$/)?.[1];
                if (endpoint.includes("/courses")) {
                    mockCourses = mockCourses.filter((item) => item.id != targetId);
                } else if (endpoint.includes("/batches")) {
                    mockBatches = mockBatches.filter((item) => item.id != targetId);
                } else if (endpoint.includes("/students")) {
                    mockStudents = mockStudents.filter((item) => item.id != targetId);
                } else if (endpoint.includes("/batch-enrollments")) {
                    mockBatchEnrollments = mockBatchEnrollments.filter(
                        (item) => item.id != targetId
                    );
                } else if (endpoint.includes("/evaluations")) {
                    const idx = evaluationsDataStore.findIndex((item) => item.id == targetId);
                    if (idx !== -1) {
                        evaluationsDataStore[idx] = {
                            ...evaluationsDataStore[idx],
                            isActive: false,
                            isArchived: true,
                            status: "ARCHIVED",
                            updatedDate: new Date().toISOString(),
                        };
                        saveEvaluationsStore(evaluationsDataStore);
                    }
                }
                resolve({ success: true });
            } else if (method === "GET") {
                // Handle specific GET endpoints
                const urlId = endpoint.match(/\/([^/?]+)$/)?.[1];
                const requestId = body?.id || (urlId && !isNaN(urlId) ? urlId : undefined);

                // Handle individual batch fetch
                if (endpoint.includes("/batches") && !endpoint.includes("/students")) {
                    const batchId = endpoint.match(/\/batches\/([^\/]+)/)?.[1];
                    if (batchId) {
                        const foundBatch = mockBatches.find((batch) => batch.id === parseInt(batchId)); // Use strict equality
                        console.log(
                            `[MOCK API] Found batch ${batchId}:`,
                            foundBatch
                        );
                        resolve(foundBatch);
                        return;
                    }
                }

                // Handle batch-specific students endpoint
                if (endpoint.includes("/batches") &&
                    endpoint.includes("/students")) {
                    const batchId = endpoint.match(
                        /\/batches\/([^\/]+)\/students/
                    )?.[1];
                    if (batchId) {
                        const batchStudents = mockStudents.filter(
                            (student) => student.batchId === parseInt(batchId) // Use strict equality
                        );
                        console.log(
                            `[MOCK API] Returning students for batch ${batchId}:`,
                            batchStudents
                        );
                        resolve(batchStudents);
                        return;
                    }
                }

                // Handle batch assignments endpoints
                if (endpoint.includes("/batch-assignments/batch")) {
                    const batchId = endpoint.match(
                        /\/batch-assignments\/batch\/([^\/]+)/
                    )?.[1];
                    if (batchId) {
                        if (endpoint.includes("/assignments")) {
                            // Get assignments for a specific batch
                            const batchAssignments = mockAssignments.filter(
                                (assignment) => assignment.batch?.id === parseInt(batchId) // Convert to number for strict equality
                            );
                            console.log(
                                `[MOCK API] Returning assignments for batch ${batchId}:`,
                                batchAssignments
                            );
                            resolve(batchAssignments);
                            return;
                        } else if (endpoint.includes("/evaluations")) {
                            // Get unique evaluations for a specific batch
                            console.log(`[MOCK API] Fetching evaluations for batch ${batchId}`);
                            console.log(`[MOCK API] Total assignments: ${mockAssignments.length}`);

                            const batchAssignments = mockAssignments.filter(
                                (assignment) => assignment.batch?.id === parseInt(batchId) // Convert to number for strict equality
                            );
                            console.log(`[MOCK API] Found ${batchAssignments.length} assignments for batch ${batchId}:`, batchAssignments);

                            const uniqueEvaluations = batchAssignments
                                .map((assignment) => {
                                    console.log(`[MOCK API] Mapping assignment ${assignment.id} with evaluationLink ${assignment.evaluationLink}`);
                                    const evaluation = mockEvaluations.find(
                                        (e) => e.id === assignment.evaluationLink // Use strict equality since both are now numbers
                                    );
                                    console.log(`[MOCK API] Found evaluation:`, evaluation);
                                    return evaluation;
                                })
                                .filter((evaluation) => evaluation !== undefined) // Filter out undefined evaluations
                                .filter(
                                    (evaluation, index, self) => index === self.findIndex((e) => e.id === evaluation.id) // Use strict equality
                                );
                            console.log(
                                `[MOCK API] Returning unique evaluations for batch ${batchId}:`,
                                uniqueEvaluations
                            );
                            resolve(uniqueEvaluations);
                            return;
                        }
                    }
                }

                // Handle course-specific evaluations
                if (endpoint.includes("/courses") &&
                    endpoint.includes("/evaluations")) {
                    const courseId = endpoint.match(
                        /\/courses\/([^\/]+)\/evaluations/
                    )?.[1];
                    if (courseId) {
                        if (requestId) {
                            // Specific evaluation for a course
                            const courseEvaluations = evaluationsDataStore.filter(
                                (evaluation) => evaluation.courseId == courseId || evaluation.course?.id == courseId
                            );
                            const foundEvaluation = courseEvaluations.find(
                                (e) => e.id == requestId // Use == for type coercion
                            );
                            console.log(
                                `[MOCK API] Found evaluation ${requestId} for course ${courseId}:`,
                                foundEvaluation
                            );
                            resolve(foundEvaluation);
                            return;
                        } else {
                            // All evaluations for a course
                            evaluationsDataStore = getEvaluationsStore();
                            let courseEvaluations = evaluationsDataStore.filter(
                                (evaluation) => evaluation.courseId == courseId || evaluation.course?.id == courseId
                            );
                            if (endpoint.includes("isActive.equals=true")) {
                                courseEvaluations = courseEvaluations.filter((item) => item.isActive !== false && !item.isArchived && item.status !== "ARCHIVED");
                            } else if (endpoint.includes("isActive.equals=false")) {
                                courseEvaluations = courseEvaluations.filter((item) => item.isActive === false || item.isArchived === true || item.status === "ARCHIVED");
                            }
                            console.log(
                                `[MOCK API] Returning evaluations for course ${courseId}:`,
                                courseEvaluations
                            );
                            resolve(courseEvaluations);
                            return;
                        }
                    }
                }

                if (requestId) {
                    // Specific item fetch
                    const foundItem = dataStore.find((c) => c.id == requestId); // Use == for type coercion
                    console.log(
                        `[MOCK API] Found item for ID ${requestId} in ${endpoint}:`,
                        foundItem
                    );
                    resolve(foundItem);
                } else if (endpoint.includes("/students") &&
                    body?.requestedEnrollmentCourseId) {
                    resolve(
                        mockStudents.filter(
                            (s) => s.requestedEnrollmentCourseId == body.requestedEnrollmentCourseId // Use == for type coercion
                        )
                    );
                } else {
                    // All items fetch
                    let results = dataStore;
                    if (endpoint.includes("isActive.equals=true")) {
                        results = results.filter((item) => item.isActive !== false && !item.isArchived && item.status !== "ARCHIVED");
                    } else if (endpoint.includes("isActive.equals=false")) {
                        results = results.filter((item) => item.isActive === false || item.isArchived === true || item.status === "ARCHIVED");
                    }
                    console.log(
                        `[MOCK API] Returning items for ${endpoint}:`,
                        results
                    );
                    resolve(results);
                }
            } else {
                reject(new Error("Unsupported mock method"));
            }
        }, 500);
    });
}
